import AppConfig from '@/modules/core/client/app/config';
import '@/modules/core/client/core.client.module';

AppConfig.registerModule('guest', ['core']);

// config
require('@/modules/hosting/client/config/hosting.client.routes');

angular.module('guest').config(hostingRoutes);

/* @ngInject */
function hostingRoutes($stateProvider) {
  $stateProvider.state('myguest', {
    url: '/myguest',
    template: `<Guest currentUser="app.user"></Guest>`,
    requiresAuth: true,
    data: {
      pageTitle: 'guest',
    },
  });
  $stateProvider.state('trips', {
    url: '/mytrips',
    template: '<Trips currentUser="app.user"></Trips>',
    requiresAuth: true,
    footerHidden: false,
    data: {
      pageTitle: 'trips',
    },
  });
}
